import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Chiara M.',
  role: 'Insegnante Vinyasa',
  location: 'Milano, Italia',
  quote: 'Ho recuperato i miei weekend. Prima passavo ore su Pinterest — ora apro il kit e ho la sequenza e il tema filosofico pronti. Le mie allieve adorano le nuove classi.',
  initials: 'CM',
  color: '#8B6FBF'
}, {
  name: 'Elena V.',
  role: 'Studio Owner',
  location: 'Roma, Italia',
  quote: 'Le schede terapeutiche sono oro puro. Mi hanno dato la sicurezza necessaria per gestire allievi con ernie o problemi cervicali. Non improvviso più, vado con un piano.',
  initials: 'EV',
  color: '#D4A574'
}, {
  name: 'Federica T.',
  role: 'Insegnante Freelance',
  location: 'Napoli, Italia',
  quote: 'È molto più di un semplice PDF. È un sistema pedagogico completo. Insegno da 5 anni e questo kit ha portato una ventata di freschezza incredibile alla mia pratica.',
  initials: 'FT',
  color: '#0F8B6F'
}, {
  name: 'Giulia R.',
  role: 'Insegnante Hatha Yoga',
  location: 'Firenze, Italia',
  quote: 'Le 52 intenzioni filosofiche danno un\'anima diversa a ogni classe. Le mie allieve mi dicono che escono dalla lezione trasformate, non solo "allenate".',
  initials: 'GR',
  color: '#D98AA8'
}, {
  name: 'Sara B.',
  role: 'Yoga Terapeutico',
  location: 'Torino, Italia',
  quote: 'I protocolli per over 60 e menopausa sono stati una rivelazione. Finalmente ho un riferimento serio per le mie allieve con esigenze specifiche.',
  initials: 'SB',
  color: '#8B6FBF'
}, {
  name: 'Martina L.',
  role: 'Insegnante Vinyasa Flow',
  location: 'Bologna, Italia',
  quote: 'Il manuale delle transizioni mi ha cambiato il modo di insegnare. I miei flow ora scorrono come una danza, senza più "buchi" tra una posa e l\'altra.',
  initials: 'ML',
  color: '#D4A574'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-258">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-259"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-260">
        <div className="text-center mb-10 sm:mb-14" data-id="element-261">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-262">
            ⭐ Testimonianze Reali
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-263">
            Cosa dicono le insegnanti{' '}
            <span className="text-primary" data-id="element-264">italiane</span>.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-265">
            <span className="text-[#E0A52E] text-base sm:text-lg" data-id="element-266">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-267">
              4.9/5 (+800 Recensioni Verificate)
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-268">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(90,70,120,0.15)] flex flex-col relative" data-id="element-269">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/15 leading-none select-none" data-id="element-270">
                "
              </span>

              <div className="text-[#E0A52E] text-sm mb-3" data-id="element-271">⭐⭐⭐⭐⭐</div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-272">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-273">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-274">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-275">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-276">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-277">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-278">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-279">
          Oltre{' '}
          <span className="text-primary font-bold" data-id="element-280">15.000 insegnanti</span> nel
          mondo insegnano già con YOGA PRONTA.
        </p>
      </div>
    </section>;
}